import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_wef5szym8e: FaireBrandEntity = {
  token: "b_wef5szym8e",
  type: "brand",
  name: "AlchePharma Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/4adba79f58801f4081c092857f64b68a5ee9d9719c7b766c256ca7acb9d84245.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/cbf6f203de224a3ebb66a62e44c71dfbdf5c330b69ec9a9ca7420bded36d815f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4adba79f58801f4081c092857f64b68a5ee9d9719c7b766c256ca7acb9d84245.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cbf6f203de224a3ebb66a62e44c71dfbdf5c330b69ec9a9ca7420bded36d815f.png",
  location: "Nipomo, CA, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 4,
  isInsider: true,
  description:
    "AlchePharma Naturals: Connecting Wellness Brands with Retailers\n\nAt AlchePharma Naturals, we specialize in bringing trusted natural health and wellness brands to retailers across the United States. As an authorized distributor and broker, our mission is simple: to make high-quality, science-backed products more accessible to communities everywhere.\n\nWe partner directly with brand principals to ensure authenticity, transparency, and first-hand access for retailers. By choosing AlchePharma Naturals, you’re not only stocking products with proven results—you’re also gaining a reliable distribution partner dedicated to your success.\n\nWe’re here to help your store grow with curated wellness brands, consistent supply, and a team that cares about both product integrity and retailer relationships.\n\nJoin us in shaping the future of natural health—one trusted product at a time.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:39.813Z",
    importedBy: "entity-db-cli",
  },
};
